import { string, object, SchemaOf } from 'yup'

export interface IProfileSchema {
    name: string
    email: string
    currentPassword: string
}

const profileSchema: SchemaOf<IProfileSchema> = object().shape({
    name: string().required('Preencha o campo com seu nome.').max(100, 'Máx 100 caracteres'),
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.').max(100, 'Máx 100 caracteres'),
    currentPassword: string().required('Preencha o campo com sua senha atual.').max(20, 'Máx 20 caracteres'),
})

export default profileSchema
